module.exports = __webpack_public_path__ + "static/images/smallfoot.60d2ed1429758819e694c4fbc909494d.jpg";